export default "__VITE_ASSET__BtGgWwDJ__"